export const buildTrafficTakeaway = (trafficSources) => {
  const channels = trafficSources?.channels || [];
  const top = channels[0];
  const second = channels[1];

  if (!top) return null;

  if (top.channel === "Organic Search" && second?.channel === "Direct") {
    return "Most families either searched for you on Google or went straight to your website — a healthy mix of online discovery and word-of-mouth.";
  }

  if (top.channel === "Direct") {
    return "Most visitors already knew your website — a strong sign that families are sharing your link and coming back.";
  }

  if (top.channel === "Organic Search") {
    return "Most visitors found you through Google or other search — families are actively looking for gymnastics online.";
  }

  if (top.channel === "Organic Social") {
    return "Social media is your biggest traffic driver — your Facebook and Instagram posts are bringing people to the site.";
  }

  const parts = [`Most visitors come from ${top.friendlyLabel || top.channel} (${top.sharePercent}%)`];
  if (second && second.sharePercent >= 10) {
    parts.push(`with ${second.friendlyLabel || second.channel} close behind (${second.sharePercent}%)`);
  }
  return `${parts.join(", ")}.`;
};

export const formatVisitCount = (count) => {
  const n = Number(count) || 0;
  return `${n.toLocaleString()} ${n === 1 ? "visit" : "visits"}`;
};
